import Vue from "vue";
import Router from "vue-router";
import Index from "./components/Index.vue";

Vue.use(Router);

const getBasePath = () => {
	// Add safety check for window.webinars_data
	if (!window.webinars_data) {
		console.error("window.webinars_data is undefined. This might indicate that webinars router is being loaded incorrectly.");
		return "/webinars"; // Default fallback
	}

	if (window.webinars_data.locale === "en") {
		return "/webinars";
	}
	// see if url path begins with jp-refresh or jp...
	const path = window.location.pathname;
	if (path.startsWith("/jp-refresh")) {
		return "/jp-refresh/webinars";
	}

	return "/jp/webinars";
};

export default new Router({
	mode: "history",
	// base: "/webinars", //un-comment this line for local environment
	base: getBasePath(),
	routes: [
		{
			path: "/",
			name: "index",
			component: Index,
			// Automatic region selection for non-en locales
			beforeEnter: (to, from, next) => {
				// Add safety check for window.webinars_data
				if (!window.webinars_data || (to.fullPath === "/" && from.fullPath === "/" && Object.keys(from.query).length === 0)) {
					if (window.webinars_data && window.webinars_data.locale === "ja") {
						next({ name: "index", query: { regions: "APAC" } });
					}
				}

				next();
			},
		},
	],
});
